<template>
  <ValidationProvider
    vid="test drive date"
    rules="required"
    v-slot="{ errors }"
    mode="passive"
    tag="div"
    name="test drive date"
  >
    <div>
      <h5>{{ currentMonth.format('MMMM') }} {{ currentYear }}</h5>
      <div class="my-2 calendar">
        <div
          class="d-inline-block date-container"
          v-for="(weekdays, index) in $t('message.testDrive.weekdayLetters')"
          :key="`${index}a`"
        >
          <p class="p-xsmall text-muted">{{ weekdays }}</p>
        </div>
        <hr class="mx-1 mb-0" />
        <div class="d-inline-block date-container" v-for="(weekdays, index) in daysBefore" :key="`${index}b`">
          <p class="p-xsmall greyed-out">{{ weekdays }}</p>
        </div>
        <div
          class="d-inline-block date-container"
          v-for="(weekdays, indexForPicker) in availableDays"
          :key="`${indexForPicker}c`"
        >
          <input
            type="radio"
            v-model="innerValue"
            name="days"
            :id="`${indexForPicker}c`"
            :value="weekdays"
            data-cy="calendarDay"
          />
          <label :for="`${indexForPicker}c`" class="d-inline mx-auto"
            ><div class="h-100 w-100">
              <p class="p-xsmall">{{ weekdays }}</p>
            </div></label
          >
        </div>
        <div class="d-inline-block date-container" v-for="(weekdays, index) in daysAfter" :key="`${index}d`">
          <p class="p-xsmall greyed-out">{{ weekdays }}</p>
        </div>
      </div>
    </div>
  </ValidationProvider>
</template>
<script>
import moment from 'moment';
import { ValidationProvider } from 'vee-validate';
import format from 'date-fns/format';

export default {
  components: {
    ValidationProvider,
  },
  name: 'MobileDatePicker',
  data() {
    return {
      currentMonth: moment(),
      nextMonth: moment().add(1, 'month'),
      currentYear: moment().format('YYYY'),
      nextYear: moment().add(1, 'year').format('YYYY'),
      endOfMonth: parseInt(moment().endOf('month').format('DD'), 0),
      beginningOfWeek: parseInt(moment().startOf('week').format('DD'), 0),
      finalDate: parseInt(moment().add(13, 'days').endOf('week').format('DD'), 0),
      innerValue: '',
      currentHour: moment().format('HH'),
      endOfLastMonth: parseInt(moment().subtract('1', 'month').endOf('month').format('DD'), 0),
    };
  },
  computed: {
    currentDay() {
      if (this.currentHour > 21) {
        return parseInt(moment().format('DD'), 0) + 1;
      }
      return parseInt(moment().format('DD'), 0);
    },
    determinedLanguage() {
      return this.$store.state.user.language;
    },
    availableDays() {
      const holder = [];
      for (let i = this.currentDay; i <= this.currentDay + 13; i += 1) {
        if (i > this.endOfMonth) {
          holder.push(i - this.endOfMonth);
        } else {
          holder.push(i);
        }
      }
      return holder;
    },
    daysBefore() {
      const holder = [];
      let firstDay = this.beginningOfWeek;
      if (firstDay === this.currentDay) {
        firstDay -= 7;
        firstDay = firstDay < 1 ? this.endOfLastMonth + firstDay : firstDay;
      }
      if (this.currentDay > firstDay) {
        for (let i = firstDay; i < this.currentDay; i += 1) {
          holder.push(i);
        }
      } else {
        for (let i = firstDay; i < this.endOfLastMonth + this.currentDay; i += 1) {
          holder.push(((i - 1) % this.endOfLastMonth) + 1);
        }
      }
      return holder;
    },
    daysAfter() {
      const holder = [];
      const lastAvailableDay = this.availableDays[this.availableDays.length - 1];

      if (this.finalDate === lastAvailableDay) {
        return holder;
      }

      let lastDate = this.finalDate;
      if (this.finalDate < lastAvailableDay) {
        lastDate += this.endOfMonth;
      }

      for (let i = lastAvailableDay + 1; i <= lastDate; i += 1) {
        holder.push(((i - 1) % this.endOfMonth) + 1);
      }
      return holder;
    },
  },
  beforeCreate() {
    if (this.$store.state.user.language === 'fr_CA') {
      moment.locale('fr-ca');
    }
  },
  created() {
    const date = this.$store.state.testDrive.driveDate;
    if (date) {
      this.innerValue = format(date, 'D');
    }
  },
  watch: {
    innerValue(newVal) {
      let theMonth;
      let theYear;

      if (newVal >= this.currentDay) {
        theMonth = this.currentMonth;
        theYear = this.currentYear;
      } else {
        theMonth = this.nextMonth;
        theYear = this.currentYear;
        if (theMonth.format('MM') === '01') {
          theYear = this.nextYear;
        }
      }
      this.$emit('input', `${theYear}/${theMonth.format('MM')}/${newVal}`);
    },
    value(newVal) {
      this.innerValue = newVal;
    },
  },
};
</script>
<style lang="scss" scoped>
@import 'src/assets/scss/variables';
p {
  padding-top: 8px;
  margin-top: 0;
  text-align: center;
}
.date-container {
  cursor: pointer;
  width: 34px;
  height: 34px;
  margin-right: 8px;
  margin-left: 8px;
  label {
    div {
      border-radius: 22px;
    }
  }
  input[type='radio'] {
    opacity: 0;
    width: 0px;
  }
  input[type='radio']:hover + label {
    background: $primary-light-background;
  }
  input[type='radio']:checked + label {
    p {
      color: white;
    }
    div {
      background: $primary;
    }
  }
}
.calendar {
  width: 350px;
}
.greyed-out {
  color: #c6cace;
}
</style>
